import { getSupportEmail } from '../support/supportEmail'

export const getErrorMapping = (errorType, supportEmail = getSupportEmail() ?? '') => {
	switch (errorType) {
		case 'UNAUTHORIZED_ACCESS':
			return "You're logged out because you don't have right access. If you're granted right access please try signing again."
		case 'NOT_CONNECTED_TO_MERCHANT':
			return `You are not connected to any merchant. please contact us at ${supportEmail}`
		case 'INVITE_ALREADY_ACCEPTED_OR_DENIED':
			return `Invite has already been used or is expired. If you already have account you can login <a href="/login">here</a> or contact us at <a href="mailto:${supportEmail}">${supportEmail}</a> for further info.`
		case 'ACCOUNT_MULTIPLE_OF_SAME_TYPE':
			return `The account information is not available at the moment. Please contact us at ${supportEmail}`
		case 'AUTH_INVALID_TOKEN':
			return `There was a problem with the authentication. Please try again later or contact us at ${supportEmail}`
		case 'CLASSIFICATION_PARENT_DOES_NOT_EXIST':
			return `Could not get the category of your merchant at the moment. Please contact us at ${supportEmail}`
		case 'CLASSIFICATION_LIST_ERROR':
			return `Could not get the category of your merchant at the moment. Please try again later or contact us at ${supportEmail}`
		case 'CLASSIFICATION_DOES_NOT_EXIST':
			return `No categories are attached to your merchant. Please contact us at ${supportEmail}`
		case 'CONSENT_TERM_NOT_FOUND':
			return `Could not load the terms at the moment. Please contact us at ${supportEmail}`
		case 'CONTRACTget_ERROR':
			return `Could not handle the contract at the moment. Please try again later or contact us at ${supportEmail}`
		case 'FRONTEND_LOGIN_SERVICE_TIMEOUT':
			return `Could not login at the moment. Please try again later or contact us at ${supportEmail}`
		case 'FRONTEND_COREID_CLIENT_ERROR':
			return `Could not reach the login service at the moment. Please try again or contact us at ${supportEmail}`
		case 'FRONTEND_LOGIN_SERVICE_ERROR':
			return `The login service could not complete. Please try again or contact us at ${supportEmail}`
		case 'FRONTEND_LOGIN_SERVICE_CANCELLED':
			return `The login service was cancelled. Please try again or contact us at  ${supportEmail}`
		case 'FRONTEND_LOGIN_SERVICE_FAILED':
			return `The login service failed. Please try again or contact us at ${supportEmail}`
		case 'FRONTEND_LOGIN_SERVICE_NO_TOKEN':
			return `Something went wrong with the login service. Please try again or contact us at ${supportEmail}`
		case 'FRONTEND_VERIFICATION_TOKEN_NOT_PROVIDED':
			return `Verification link not valid. Please provide a valid link or contact us at ${supportEmail}`
		case 'IMAGE_UPLOAD_ERROR':
			return `Could not upload an image at the moment. Please contact us at ${supportEmail}`
		case 'INVITE_LIST_ERROR':
			return `Could not handle the invite at the moment. Please contact us at ${supportEmail}`
		case 'INVITE_SEND_MAIL_ERROR':
			return `Could not send the invite at the moment. Please try again later or contact us at ${supportEmail}`
		case 'INVITE_HAS_EXPIRED':
			return `Your invite has expired. Please contact us at ${supportEmail}`
		case 'MERCHANT_DOES_NOT_EXIST':
			return `The current merchant is not available at the moment. Please contact us at ${supportEmail}`
		case 'MERCHANT_IS_INACTIVE':
			return `The current merchant is inactive. Please contact us at ${supportEmail}`
		case 'MERCHANT_SEARCH_ERROR':
			return `Could not search for a merchant at the moment. Please contact us at ${supportEmail}`
		case 'MERCHANT_LIST_ERROR':
			return `Could not list merchants at the moment. Please contact us at ${supportEmail}`
		case 'MERCHANT_INVALID_COMPETITORS':
			return `One or multiple selected comparing merchants are invalid. Please contact us at ${supportEmail}`
		case 'MERCHANT_LIST_COMPETITORS_ERROR':
			return `Could not list comparing merchants at the moment. Please contact us at ${supportEmail}`
		case 'MERCHANT_UPDATE_ERROR':
			return `Could not update your brand profile at the moment. Please contact us at ${supportEmail}`
		case 'UNHANDLED_CURRENCY':
			return `We cannot load this merchant because its account currency is not supported. Please contact us at <a href="mailto:${supportEmail}">${supportEmail}</a>`
		case 'OFFER_INVALID_STATUS':
			return `The current offer is not available at the moment. Please contact us at ${supportEmail}`
		case 'OFFER_CREATION_ERROR':
			return `Could not create an offer at the moment. Please contact us at ${supportEmail}`
		case 'OFFER_CREATE_MULTIPLE_LIVE_OFFERS':
			return 'You already have this type of campaign live.'
		case 'OFFER_CREATE_NOT_ENOUGH_BUDGET':
			return 'Could not create an offer at the moment. Not enough budget.'
		case 'PAYMENT_TERM_NOT_FOUND':
			return `Could not retrieve the contract at the moment. Please contact us at ${supportEmail}`
		case 'STRIPE_SCRIPT_LOAD_ERROR':
			return `Could not load payment service at the moment. Please try again later or contact us at ${supportEmail}`
		case 'TERMS_HAVE_NOT_BEEN_ACCEPTED':
			return `The terms and condition have not been accepted. Please go to Payments -> Update information and accept the terms and condition or contacts us at ${supportEmail}`
		case 'TERMS_PDF_READER_LOAD_ERROR':
			return `Could not load the terms and condition. Please try again later or contacts us at ${supportEmail}`
		case 'USER_DOES_NOT_EXIST':
			return `User does not exist. Contacts us at ${supportEmail}`
		case 'user does not exist':
			return 'User does not exist. Please register to create an account'
		case 'user already exist':
			return `User already exists. use forgot password to reset password or contacts us at ${supportEmail}`
		case 'TOO_MANY_LOGIN_ATTEMPTS':
			return `Too many login attempts. Please try again later or contacts us at ${supportEmail}`
		case 'EMAIL_AND_PASSWORD_DO_NOT_MATCH':
			return `Invalid credentials. If you have forgotten your password, you can reset it <a href="/reset-password">here</a> or contact us <a href="mailto:${supportEmail}">here</a>`
		case 'INVALID_EMAIL':
			return 'Invalid email. Please enter a valid email address.'
		case 'INVALID_OTP':
			return 'Invalid input. Either email does not exist and/or one time password is wrong.'
		case 'TOO_MANY_OTP_ATTEMPTS':
			return `Too many attempts. Please try again later or contacts us at ${supportEmail}`
		case 'TOO_MANY_CONCURRENT_OTP':
			return `Max amount of concurrent one time passwords reached. Please try again later or contacts us ${supportEmail}`
		case 'ERR_FAILED_SAVE_BUSINESS_INFO':
			return 'Failed to save billing information. Please try again!'
		case 'INVITE_ALREADY_EXISTS':
			return 'The user is already invited!'
		case 'File is not an image':
			return 'File is not an image. Please select an image file.'
		default:
			return `Oops! Something went wrong! Please try again later or contacts us at ${supportEmail}`
	}
}
